import { type RefObject, useEffect, useState } from 'react';

export const useShowStickyBar = (
  topElement: RefObject<HTMLDivElement | null>,
  mainElement: RefObject<HTMLDivElement | null>,
) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (!topElement.current || !mainElement.current) return;

    let isTopElementVisible = true;
    let isMainContentVisible = false;

    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.target === topElement.current) {
          isTopElementVisible = entry.isIntersecting;
        } else if (entry.target === mainElement.current) {
          isMainContentVisible = entry.isIntersecting;
        }
      });
      setIsVisible(!isTopElementVisible && isMainContentVisible);
    }, {});

    observer.observe(topElement.current);
    observer.observe(mainElement.current);

    return () => observer.disconnect();
  }, [topElement, mainElement]);

  return isVisible;
};
